import React from 'react';

import { Connect } from '@rover/react-lib/src/components/utils/Redux';
import events from '@rover/react-lib/src/pages/search/SearchPage/analytics';
import {
  effects as searchFiltersEffects,
  selectors as searchFiltersSelectors,
} from '@rover/react-lib/src/pages/search/SearchPage/SearchFilters.duck';
import { effects as searchPageEffects } from '@rover/react-lib/src/pages/search/SearchPage/SearchPage.duck';

import WizardFiltersCollection from './WizardFiltersCollection';

export type Props = {
  onSubmit: () => void;
};

const effects = {
  setFiltersInitialStateBasedOnBrand: searchFiltersEffects.setFiltersInitialStateBasedOnBrand,
  fireAnalyticsEvent: searchPageEffects.fireAnalyticsEvent,
  fireSearch: searchPageEffects.fireSearch,
  updateFilters: searchFiltersEffects.updateFilters,
  fireSearchPageSearchCTAEvent: searchPageEffects.fireSearchPageSearchCTAEvent,
};

const selector = (state) => ({
  isCatOnly: searchFiltersSelectors.getIsCatOnly(state),
  searchFilters: searchFiltersSelectors.getFilters(state),
  serviceTypeFilterOptions: searchFiltersSelectors.getServiceTypeFilterOptions(state),
  serviceTypeOptions: searchFiltersSelectors.getPetTypeBrowsableServiceTypeOptions(state),
});

const WizardFiltersCollectionContainer = (props: Props): JSX.Element => (
  <Connect
    selector={selector}
    effects={effects}
    onMount={() => searchPageEffects.fireAnalyticsEvent(events.SearchOwnerPreferencesDisplayEvent)}
  >
    {(connectedProps) => <WizardFiltersCollection {...connectedProps} {...props} />}
  </Connect>
);

export default WizardFiltersCollectionContainer;
